import ImagesPressLogosBlueSpiritoryJpg from '@/public/images/press/logos/blue/spiritory.jpg';
import ImagesPressLogosBlueSpiritoryLogoJpg from '@/public/images/press/logos/blue/spiritoryLogo.jpg';
import ImagesPressLogosBlueSpiritoryLogoPng from '@/public/images/press/logos/blue/spiritoryLogo.png';
import ImagesPressLogosBlueSpiritoryLogoSvg from '@/public/images/press/logos/blue/spiritoryLogo.svg';
import ImagesPressLogosBlueSpiritoryPng from '@/public/images/press/logos/blue/spiritory.png';
import ImagesPressLogosBlueSpiritorySvg from '@/public/images/press/logos/blue/spiritory.svg';

export {
  ImagesPressLogosBlueSpiritoryJpg,
  ImagesPressLogosBlueSpiritoryLogoJpg,
  ImagesPressLogosBlueSpiritoryLogoPng,
  ImagesPressLogosBlueSpiritoryLogoSvg,
  ImagesPressLogosBlueSpiritoryPng,
  ImagesPressLogosBlueSpiritorySvg,
};
